/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'CANTEEN_EATING_AREAS_ARE_SEPARATE_FROM_THE_PRODUCTION_AREAS_EVE',
              'CANTEEN_EATING_AREAS_ARE_PROTECTED_FROM_THE_ELEMENTS_AND_PROVID',
              'FOOD_PREPARATION_STORAGE_AND_EATING_AREAS_ARE_KEPT_CLEAN_SAFE_A',
              'FOOD_IS_PREPARED_IN_A_MANNER_THAT_REDUCES_THE_POTENTIAL_FOR_FOO',
              'FOOD_SERVICE_WORKERS_RECEIVE_ANNUAL_MEDICAL_EXAMINATIONS_TO_ENS',
              'FOOD_SERVICE_WORKERS_HANDLING_FOOD_ARE_TRAINED_ABOUT_AND_FOLLOW',
              'NONE_OF_THE_ABOVE',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    does_the_fac_have_any_of_the_following_safety_measures_in_place_17: valueSchema,
  },
}
